require('./cart-item-count-incrementor/cart-item-count-incrementor.scss');
var BaseViews = require('../../base');

var CartItemCountIncrementor = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-item-count-incrementor container-fluid',
    template: require('./cart-item-count-incrementor/cart-item-count-incrementor.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'light'
            }
        );
        this.model.on('change:cartCount', function () {
          self._renderCount();
        });
    },
    ui: {
      count: '.fmcy-cart-item-count-incrementor-count',
      countPlus: '.fmcy-cart-item-count-incrementor-plus',
      countMinus: '.fmcy-cart-item-count-incrementor-minus'
    },
    triggers: {
      'click @ui.countPlus': 'click:plus',
      'click @ui.countMinus': 'click:minus'
    },
    _renderCount: function () {
      if (this.ui.count && typeof this.ui.count.html == 'function') {
        this.ui.count.html(this.model.get('cartCount'));
      }
    },
    onDestroy: function () {
      this.model.off('change:cartCount');
    },
    serializeData: function () {
      return {
        cartCount: this.model.get('cartCount')
      }
    }
});

module.exports = CartItemCountIncrementor;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-review/cart-item-count-incrementor.js
 **/